export default __webpack_public_path__ + "static/logo-c372c0f19bf568bee0e660ed313d6eb7.png";